'use strict';

var Function = function(name, args)
{
  this.name = name;
  this.args = args;
}

module.exports = Function;

